const Input = {
  isComponent: el => el.tagName === 'INPUT',
  model: {
    defaults: Object.assign({}, {
      tagName: 'input',
      draggable: 'form, form *',
      droppable: false,
      copyable: false,
      attributes: {
        id: 'input',
        type: 'text',
        value: '',
        name: '',
        placeholder: 'Insert text here',
        required: false,
        readonly: false
      },
      traits: [
        { type: 'text', name: 'id', label: 'ID', placeholder: 'ID' },
        {
          type: 'select',
          name: 'type',
          label: 'Type',
          placeholder: 'Type',
          options: ['date', 'email', 'number', 'password', 'tel', 'text', 'time', 'url']
        },
        { type: 'text', name: 'value', label: 'Value', placeholder: 'Value' },
        { type: 'text', name: 'name', label: 'Name', placeholder: 'Name' },
        { type: 'text', name: 'placeholder', label: 'Placeholder', placeholder: 'Placeholder' },
        { type: 'checkbox', name: 'required', label: 'Required' },
        { type: 'checkbox', name: 'readonly', label: 'Readonly' }
      ]
    }),
    init() {
      this.handleTypeChange()
      this.on('change:attributes:type', this.handleTypeChange)
    },
    updated(property, newVal, oldVal) {
      const attributes = this.getAttributes()
      if (property === 'attributes') {
        if (newVal.type !== oldVal.type) {
          if (oldVal.type === 'number') {
            delete attributes.min
            delete attributes.max
            delete attributes.step
          }
        }
      }
      this.setAttributes(attributes)
    },
    handleTypeChange() {
      const attributes = this.getAttributes()
      if (attributes.type === 'number') {
        this.addTrait({ type: 'number', name: 'min', placeholder: 'min' }, { at: 5 })
        this.addTrait({ type: 'number', name: 'max', placeholder: 'max' }, { at: 6 })
        this.addTrait({ type: 'number', name: 'step', placeholder: 'step' }, { at: 7 })
      } else {
        this.removeTrait('min')
        this.removeTrait('max')
        this.removeTrait('step')
      }
    }
  }
}

export default Input
